import { queryTransactions, editTransaction, deleteTransaction } from "@/api";
//
export default {
  namespaced: true,

  state: {
    transactions: [],
    totalPages: 0,
    totalDocs: 0,
    page: 1,
    limit: 50,
    sort: "-_id",
    searchString: "",
    filterdata: "",
    filterDateFrom: null,
    filterDateTo: null,
    filterGiveIsCash: false,
    filterGetIsCash: false,
    filterGiveValutes: [],
    filterGetValutes: [],
    isFiltered: false,
    loading: true,
    query: null,
    exportDescr: "",
    queryTemplates: [
      {
        type: "operators",
        title: "Операторы",
        level: 1,
        query: {
          $and: [
            { $or: [{ isOpex: false }, { isOpex: { $exists: false } }] },
            {
              $or: [
                { isCorrection: false },
                { isCorrection: { $exists: false } }
              ]
            },
            {
              $or: [{ isBitzlato: false }, { isBitzlato: { $exists: false } }]
            },
            {
              $or: [{ isWhitebit: false }, { isWhitebit: { $exists: false } }]
            },
            { $or: [{ isInternal: false }, { isInternal: { $exists: false } }] }
          ]
        }
      },
      // {
      //   type: "bitzlato",
      //   title: "Bitzlato",
      //   level: 1,
      //   query: {
      //     isBitzlato: true
      //   }
      // },
      // {
      //   type: "whitebit",
      //   title: "WhiteBit",
      //   level: 1,
      //   query: {
      //     isWhitebit: true
      //   }
      // },
      {
        type: "internal",
        title: "Движения средств",
        level: 1,
        query: {
          isInternal: true
        }
      },
      {
        type: "opex",
        title: "Операционные расходы",
        level: -1,
        query: {
          isOpex: true
        }
      },
      {
        type: "corrections",
        title: "Корректировки",
        level: -1,
        query: {
          isCorrection: true
        }
      }
    ],
    queryType: "operators"
  },

  mutations: {
    setTransactions(state, transactions) {
      state.transactions = transactions.map(tr => {
        return {
          ...tr,
          give: tr.giveValute,
          get: tr.getValute,
          trans: tr
        };
      });
    },
    setFilterdata(state, filterdata) {
      state.filterdata = filterdata;
    },
    setQuery(state, query) {
      state.query = query;
    },
    setExportDescr(state, exportDescr) {
      state.exportDescr = exportDescr;
    },
    setPage(state, page) {
      state.page = page;
    },
    setTotalPages(state, totalPages) {
      state.totalPages = totalPages;
    },
    setTotalDocs(state, totalDocs) {
      state.totalDocs = totalDocs;
    },
    setSort(state, sort) {
      state.sort = sort;
    },
    setLimit(state, limit) {
      state.limit = limit;
    },
    setIsFiltered(state, isFiltered) {
      state.isFiltered = isFiltered;
    },
    setSearchString(state, searchString) {
      state.searchString = searchString;
    },
    setFilterDateFrom(state, filterDateFrom) {
      state.filterDateFrom = filterDateFrom;
    },
    setFilterDateTo(state, filterDateTo) {
      state.filterDateTo = filterDateTo;
    },
    setFilterGiveIsCash(state, filterGiveIsCash) {
      state.filterGiveIsCash = filterGiveIsCash;
    },
    setFilterGetIsCash(state, filterGetIsCash) {
      state.filterGetIsCash = filterGetIsCash;
    },
    setFilterGiveValutes(state, filterGiveValutes) {
      state.filterGiveValutes = filterGiveValutes;
    },
    setFilterGetValutes(state, filterGetValutes) {
      state.filterGetValutes = filterGetValutes;
    },
    setQueryType(state, queryType) {
      state.queryType = queryType;
    },
    setLoading(state, loading) {
      state.loading = loading;
    }
  },

  actions: {
    async searchQueryBuilder(store) {
      if (
        !store.state.searchString &&
        !store.state.filterDateFrom &&
        !store.state.filterDateTo &&
        !store.state.filterGiveIsCash &&
        !store.state.filterGetIsCash &&
        !store.state.filterGiveValutes.length &&
        !store.state.filterGetValutes.length
      ) {
        store.commit("setIsFiltered", false);
        return {};
      }

      const queryBuilders = [
        {
          state: "searchString",
          builder: () => {
            const or = [
              {
                "getValute.forms.value": {
                  $regex: `.*${store.state["searchString"]}.*`,
                  $options: "i"
                }
              },
              {
                "giveValute.forms.value": {
                  $regex: `.*${store.state["searchString"]}.*`,
                  $options: "i"
                }
              },
              {
                "getValute.wallet.forms.description": {
                  $regex: `.*${store.state["searchString"]}.*`,
                  $options: "i"
                }
              },
              {
                "giveValute.wallet.forms.description": {
                  $regex: `.*${store.state["searchString"]}.*`,
                  $options: "i"
                }
              },
              {
                ip: {
                  $regex: `.*${store.state["searchString"]}.*`,
                  $options: "i"
                }
              },
              {
                paymentId: {
                  $regex: `.*${store.state["searchString"]}.*`,
                  $options: "i"
                }
              }
            ];
            if (Number(store.state["searchString"]))
              or.push(
                {
                  "giveValute.forms.value": Number(store.state["searchString"])
                },
                {
                  "getValute.forms.value": Number(store.state["searchString"])
                }
              );
            const q = {
              $or: or
            };
            if (
              store.state["searchString"].length === 12 ||
              store.state["searchString"].length === 24
            )
              q["$or"].push({ _id: store.state["searchString"] });
            return q;
          }
        },
        {
          state: "filterDateFrom",
          builder: () => {
            const q = {
              date: {
                $gte: store.state["filterDateFrom"]
              }
            };
            return q;
          }
        },
        {
          state: "filterDateTo",
          builder: () => {
            const q = {
              date: {
                $lte: store.state["filterDateTo"]
              }
            };
            return q;
          }
        },
        {
          state: "filterGiveIsCash",
          builder: () => {
            const q = {
              "giveValute.valute.isCash": store.state["filterGiveIsCash"]
            };
            return q;
          }
        },
        {
          state: "filterGetIsCash",
          builder: () => {
            const q = {
              "getValute.valute.isCash": store.state["filterGetIsCash"]
            };
            return q;
          }
        },
        {
          state: "filterGiveValutes",
          builder: () => {
            const q = {
              "giveValute.valute.bestchangeKey": {
                $in: store.state["filterGiveValutes"]
              }
            };
            return q;
          }
        },
        {
          state: "filterGetValutes",
          builder: () => {
            const q = {
              "getValute.valute.bestchangeKey": {
                $in: store.state["filterGetValutes"]
              }
            };
            return q;
          }
        }
        // {
        //   state: "creator",
        //   builder: () => {
        //     const q = {
        //       creator: store.state["creator"]
        //     };
        //     return q;
        //   }
        // }
      ];
      const query = {
        $and: queryBuilders
          .filter(b => {
            if (
              Array.isArray(store.state[b.state]) &&
              !store.state[b.state].length
            ) {
              return false;
            }
            return !!store.state[b.state];
          })
          .map(b => b.builder())
      };

      store.commit("setIsFiltered", true);
      return query;
    },
    async getTransactions(store) {
      try {
        store.commit("setLoading", true);
        const queryTemplate = null;
        // store.state.queryTemplates.find(
        //   template => template.type === store.state.queryType
        // );
        const queryBuilded = queryTemplate ? queryTemplate.query : {};
        const queryForSearch = await store.dispatch("searchQueryBuilder");
        // console.log(queryForSearch);
        const fullQuery = {
          page: store.state.page,
          limit: store.state.limit,
          sort: store.state.sort,
          query: store.state.query || { $and: [queryBuilded, queryForSearch] }
        };
        const resp = await queryTransactions(fullQuery);
        store.commit(
          "setFilterdata",
          btoa(
            JSON.stringify({
              ...fullQuery,
              description: store.state.exportDescr
            })
          )
        );
        if (resp.data.status) {
          store.commit("setTransactions", resp.data.result.docs);
          store.commit("setTotalPages", resp.data.result.totalPages);
          store.commit("setTotalDocs", resp.data.result.totalDocs);
          return resp.data.result.docs;
        }
      } catch (error) {
        console.log(error);
      } finally {
        store.commit("setLoading", false);
      }
    },
    async goToPage(store, payload) {
      if (
        payload.page &&
        store.state.totalPages &&
        store.state.totalPages >= payload.page
      ) {
        store.commit("setPage", payload.page);
        await store.dispatch("getTransactions");
      }
    },
    async changeSorting(store, payload) {
      if (payload.sort !== undefined) {
        store.commit("setSort", payload.sort);
        await store.dispatch("getTransactions");
      }
    },
    async changeLimit(store, payload) {
      if (payload.limit !== undefined) {
        store.commit("setLimit", payload.limit);
        store.commit("setPage", 1);
        await store.dispatch("getTransactions");
      }
    },
    changeSearchString(store, payload) {
      if (payload.searchString !== undefined) {
        store.commit("setSearchString", payload.searchString);
      }
    },
    changeFilterDateFrom(store, payload) {
      if (payload.filterDateFrom !== undefined) {
        store.commit("setFilterDateFrom", payload.filterDateFrom);
      }
    },
    changeFilterDateTo(store, payload) {
      if (payload.filterDateTo !== undefined) {
        store.commit("setFilterDateTo", payload.filterDateTo);
      }
    },
    changeFilterGiveIsCash(store, payload) {
      if (payload.filterGiveIsCash !== undefined) {
        store.commit("setFilterGiveIsCash", payload.filterGiveIsCash);
      }
    },
    changeFilterGetIsCash(store, payload) {
      if (payload.filterGetIsCash !== undefined) {
        store.commit("setFilterGetIsCash", payload.filterGetIsCash);
      }
    },
    changeFilterGiveValutes(store, payload) {
      if (payload.filterGiveValutes !== undefined) {
        store.commit("setFilterGiveValutes", payload.filterGiveValutes);
      }
    },
    changeFilterGetValutes(store, payload) {
      if (payload.filterGetValutes !== undefined) {
        store.commit("setFilterGetValutes", payload.filterGetValutes);
      }
    },
    changeQuery(store, payload) {
      if (payload.query !== undefined) {
        store.commit("setQuery", payload.query);
      }
    },
    onlySetPage(store, payload) {
      if (payload.page !== undefined) {
        store.commit("setPage", payload.page);
      }
    },
    onlySetSort(store, payload) {
      if (payload.sort !== undefined) {
        store.commit("setSort", payload.sort);
      }
    },
    onlySetLimit(store, payload) {
      if (payload.limit !== undefined) {
        store.commit("setLimit", payload.limit);
      }
    },
    onlySetExportDescr(store, payload) {
      if (payload.exportDescr !== undefined) {
        store.commit("setExportDescr", payload.exportDescr);
      }
    },
    async performSearch(store, payload) {
      store.commit("setPage", 1);
      await store.dispatch("getTransactions");
    },
    async resetSearch(store, payload) {
      store.commit("setSearchString", "");
      await store.dispatch("getTransactions");
    },
    async changeQueryType(store, payload) {
      if (
        payload.queryType !== undefined &&
        store.state.queryTemplates.map(t => t.type).includes(payload.queryType)
      ) {
        store.commit("setQueryType", payload.queryType);
        await store.dispatch("getTransactions");
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/transactionsNew.js